export default __webpack_public_path__ + "5e6a2b4d7bbe1fec9c3210d688d033bc.jpg";